export default __webpack_public_path__ + "static/media/about-us-icon.490d7c5b.svg";